import * as Sentry from '@sentry/browser';

// Reports video call errors to Sentry, tagged per provider so Vonage and
// Twilio error rates can be compared during the phased rollout (POD2-2065).
const makeReporter =
  provider =>
  (error, area, extra = {}) => {
    try {
      Sentry.withScope(scope => {
        scope.setTag('video_provider', provider);
        scope.setTag(`${provider}_area`, area);
        Object.entries(extra).forEach(([key, value]) => {
          scope.setExtra(key, value);
        });
        Sentry.captureException(error);
      });
    } catch {
      // Reporting must never break the calling error path.
    }
  };

export const reportVonageError = makeReporter('vonage');
export const reportTwilioError = makeReporter('twilio');
